import Layout from '@/layout';

export default [
  {
    path: '/studio',
    name: 'Studio',
    redirect: '/studio/introduceManager',
    component: Layout,
    meta: {
      title: '工作室',
      icon: 'icon-studio',
    },
    children: [
      {
        path: 'introduceManager',
        name: 'StudioIntroduceManager',
        component: () => import('@/views/studio/introduceManager.vue'),
        meta: {
          title: '工作室概况',
          showSideBar: true,
        },
      },
      {
        path: 'detailPage/:member_id',
        name: 'detailPage',
        component: () => import('@/views/studio/components/detailPage.vue'),
        meta: {
          title: '工作室',
          activePath: 'introduceManager',
        },
        hidden: true,
      },
      {
        path: 'dataDetails',
        name: 'dataDetails',
        component: () =>
          import('@/views/studio/components/introduceManager/dataDetails.vue'),
        meta: {
          title: '工作室概况-数据详情',
          activePath: 'introduceManager',
        },
        hidden: true,
        children: [
          {
            path: 'studioOverview',
            name: 'studioOverview',
            component: () =>
              import(
                '@/views/studio/components/introduceManager/studioOverview.vue'
              ),
            meta: {
              title: '工作室概况-工作室概况表-互动表',
              activePath: 'dataDetails',
            },
            hidden: true,
          },
          {
            path: 'membersDataTable',
            name: 'membersDataTable',
            component: () =>
              import(
                '@/views/studio/components/introduceManager/membersDataTable.vue'
              ),
            meta: {
              title: '工作室概况-数据详情-成员数据',
              activePath: 'dataDetails',
            },
          },
          {
            path: 'productDataTable',
            name: 'productDataTable',
            component: () =>
              '@/views/studio/components/introduceManager/productDataTable.vue',
            meta: {
              title: '工作室概况-作品数据-互动数据',
              activePath: 'dataDetails',
            },
          },
        ],
      },
      {
        path: 'manager',
        name: 'StudioManager',
        redirect: 'manager/index',
        component: () => import('@/views/studio/manager.vue'),
        meta: {
          title: '工作室管理',
          showSideBar: true,
        },
        children: [
          {
            path: 'index',
            name: 'StudioManagerEntry',
            component: () =>
              import('@/views/studio/components/applyManager/index.vue'),
            meta: {
              title: '工作室管理',
              activePath: 'manager',
              showSideBar: true,
            },
            hidden: true,
          },
          {
            path: 'apply',
            name: 'StudioManagerApply',
            component: () =>
              import('@/views/studio/components/applyManager/apply.vue'),
            meta: {
              title: '加入退出申请',
              activePath: 'manager',
            },
            hidden: true,
          },
        ],
      },
      {
        path: 'settings',
        name: 'StudioSettings',
        redirect: 'settings/index',
        component: () => import('@/views/studio/settings.vue'),
        meta: {
          title: '工作室设置',
          showSideBar: true,
        },
        children: [
          {
            path: 'index',
            name: 'settingsEntry',
            component: () =>
              import('@/views/studio/components/settings/index.vue'),
            meta: {
              title: '工作室设置-信息',
              activePath: 'settings',
              hideTitle: true,
              showSideBar: true,
            },
            hidden: true,
          },
          {
            path: 'authentication',
            name: 'authentication',
            component: () =>
              import('@/views/studio/components/settings/authentication.vue'),
            meta: {
              title: '认证工作室',
              activePath: 'settings',
            },
            hidden: true,
          },
          {
            path: 'updateBaseInfo',
            name: 'updateBaseInfo',
            component: () =>
              import('@/views/studio/components/settings/updateBaseInfo.vue'),
            meta: {
              title: '修改基础信息',
              activePath: 'settings',
            },
            hidden: true,
          },
          {
            path: 'beforeUpdateAuthInfo',
            name: 'beforeUpdateAuthInfo',
            component: () =>
              import(
                '@/views/studio/components/settings/beforeUpdateAuthInfo.vue'
              ),
            meta: {
              title: '修改认证信息',
              activePath: 'settings',
            },
            hidden: true,
          },
        ],
      },
    ],
  },
];
